module.exports = __webpack_public_path__ + "static/media/export.79d15161.svg";